import { connect } from 'react-redux';
import AddTeam from 'Components/Broadcast/Team/Add/index';
import { TeamAction } from 'Actions';

function mapStatetoProps(state){
    const { usersId, usersList, usersTotalRecords, totalRecords, formLoading, errorElement, usersCurrentPage } = state.team
    return{
        totalRecords,
        usersId,
        usersList:usersList,
        usersTotalRecords:usersTotalRecords,
        formLoading,
        errorElement,
        usersCurrentPage
    } 
}
    const mapDispatchtoProps = {
        fetchUsers:TeamAction.fetchUsers,
        addTeamImage:TeamAction.addTeamImage,
        addTeam:TeamAction.addTeam,
    }

export default connect(mapStatetoProps,mapDispatchtoProps)(AddTeam)